<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (initialized$ | async) {
    @if (isFullWidth) {
        <div fxFlexFill csHotKeys>
            <div fxLayout="column"
                 fxLayoutAlign="start start"
                 fxFlexFill>
                <mat-sidenav-container fxFlexFill>
                    <mat-sidenav-content fxFlexFill>
                        <dash-gis-map-toolbar fxFlex="none"></dash-gis-map-toolbar>
                        <dash-gis-map csMapTip [cdkContextMenuTriggerFor]="contextMenu"></dash-gis-map>
                        <button mat-fab
                                class="legend-button"
                                matTooltip="Layers"
                                (click)="openSidenav()">
                            <mat-icon svgIcon="layers"></mat-icon>
                        </button>
                    </mat-sidenav-content>
                    <mat-sidenav #sidenav (closedStart)="sidenavClosing()">
                        <dash-gis-map-legend [legendVisible]="sidenavOpen$ | async" fxFlex="100"
                                             fxLayout="column"></dash-gis-map-legend>
                    </mat-sidenav>
                </mat-sidenav-container>
            </div>
        </div>
    }
    @if (!isFullWidth) {
        <div fxFlexFill>
            <div [ngClass]="'overlay'"
                 [ngClass.xs]="['overlay', 'overlay-xs']"
                 [ngClass.sm]="['overlay', 'overlay-sm', 'enable-pegman']"
                 [ngClass.md]="['overlay', 'overlay-sm', 'enable-pegman']"
                 fxLayout="column" fxLayoutAlign="start start">
                <dash-gis-map class="map-mobile"></dash-gis-map>
                <ng-template #bottomSheetView></ng-template>
            </div>
            <mat-toolbar
                class="bottom-toolbar"
                fxLayout="row" fxLayoutAlign="space-around center">
                <button mat-icon-button (click)="openActionMenu()">
                    <mat-icon svgIcon="menu"></mat-icon>
                </button>
                <button mat-icon-button (click)="openLegendMenu()">
                    <mat-icon svgIcon="layers"></mat-icon>
                </button>
            </mat-toolbar>
        </div>
    }
}

<ng-template #contextMenu>
    <dash-gis-map-context-menu></dash-gis-map-context-menu>
</ng-template>

